"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Anchor = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AnchorMixin = require("../../mixins/components/AnchorMixin");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
/**
 * The `Anchor` component renders a basic
 * [HTML anchor element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a).
 * It inherits font styles (i.e. font-size, font-weight, etc) from its parent.
 *
 * @related ['TextButton', 'Text', 'Paragraph']
 * @since 6.0.0
 */
var Anchor = /*#__PURE__*/_styledComponents.default.a.withConfig({
  displayName: "Anchor",
  componentId: "c11n-8-107-0__sc-hn4bge-0"
})(["", ""], _AnchorMixin.AnchorMixin);
exports.Anchor = Anchor;
Anchor.displayName = 'Anchor';
Anchor.propTypes = {
  /**
   * The styled-components
   * [polymorphic "as"](https://styled-components.com/docs/api#as-polymorphic-prop) prop.
   *
   * By default, this is a basic `<a>` element, but if you are using this component for an action
   * other than navigation, you should set this to `as="button"`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any,
  /**
   * For use on dark or colored backgrounds.
   */
  inverse: _customPropTypes.default.inlineMediaQuery(_propTypes.default.bool)
};
Anchor.defaultProps = {
  as: 'a',
  inverse: false
};

/** @component */